// Form modals used to setup new tables and cards

import React, { useCallback } from 'react'
import { useAppDispatch } from '../../../store/hooks'
import { InsightsCardForm } from '../../../components/Forms/InsightsCardForm/InsightsCardForm'
import { InsightsTableForm } from '../../../components/Forms/InsightsTableForm/InsightsTableForm'
import { NameForm } from '../../../components/Forms/NameForm/NameForm'
import { updateInsightsConfig } from '../../../metrics_server/insights/actions'
import { useInsights } from '../../../metrics_server/insights/hooks'
import {
  InsightsCardConfig,
  InsightsTableConfig
} from '../../../metrics_server/insights/types'
import { useSession } from '../../../metrics_server/sessions/hooks'
import { createChallenge } from '../../../metrics_server/targets/actions'
import { useUnits } from '../../../metrics_server/units/hooks'
import { toggleModal } from '../../../ui/modal/actions'
import { setRedirect } from '../../../ui/router/actions'

export const useInsightsTableFormModal = () => {
  // Redux //
  const units = useUnits()
  const insights = useInsights()
  const dispatch = useAppDispatch()
  // ====== //

  const { session } = useSession()

  const openInsightsTableFormModal = useCallback(
    (configId: string) => {
      dispatch(
        toggleModal({
          active: true,
          type: 'confirm',
          wrapper: true,
          width: '50%',
          ChildComponent: () => (
            <InsightsTableForm
              configId={configId}
              handleProceed={(values: InsightsTableConfig) => {
                // Save / Update Table
                values.config.type = 'tables'
                dispatch(
                  updateInsightsConfig(
                    values,
                    insights.layouts.selectedId.sessionLayout
                  )
                )
                dispatch(toggleModal({}))
              }}
              handleSecondaryButton={() => {
                dispatch(toggleModal({}))
              }}
              session={session}
              units={units}
            />
          ),
          className: 'modalLarge'
        })
      )
    },
    [insights.layouts.selectedId.sessionLayout]
  )

  return {
    openInsightsTableFormModal
  }
}

export const useInsightsCardFormModal = () => {
  // Redux //
  const units = useUnits()
  const insights = useInsights()
  const dispatch = useAppDispatch()
  // ====== //

  const { session } = useSession()

  const openInsightsCardFormModal = useCallback(
    (configId: string) => {
      dispatch(
        toggleModal({
          active: true,
          type: 'confirm',
          wrapper: true,
          width: '50%',
          ChildComponent: () => (
            <InsightsCardForm
              configId={configId}
              handleProceed={(values: InsightsCardConfig) => {
                // Save / Update Table
                values.config.type = 'cards'
                dispatch(
                  updateInsightsConfig(
                    values,
                    insights.layouts.selectedId.sessionLayout
                  )
                )
                dispatch(toggleModal({}))
              }}
              handleSecondaryButton={() => {
                dispatch(toggleModal({}))
              }}
              session={session}
              units={units}
            />
          ),
          className: 'modalLarge'
        })
      )
    },
    [insights.layouts.selectedId.sessionLayout]
  )

  return {
    openInsightsCardFormModal
  }
}
